import { AuthResponse } from '../types/AuthResponse';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export async function login(email: string, password: string): Promise<AuthResponse> {
  const res = await fetch(`${API_BASE_URL}/api/users/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({'email': email, 'password': password}),
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Failed to create query: ${errorText}`);
  }

  return res.json();
}
